export default {
  selectSize: 'Por favor, selecione especificações completas',
  inventory: 'Estoque',
  num: 'Quantidade',
  nimNumTips: 'Quantidade mínima de compra: {num}',
  addCart: 'Adicionar ao carrinho',
  nowBuy: 'Comprar agora',
  remark: 'Mensagem',
  goShop: 'Entrar na loja',
  productTotalPrice: 'Preço total do produto',
  productDetail: 'Detalhes do produto',
  sizeParams: 'Parâmetros de especificação',
  shopNotes: 'Notas de compra',
  saleService: 'Serviço pós-venda',
  productInfo: 'Informações do produto',
  buyTips: 'Após o pagamento, faremos o serviço de compra para você das 09:00 às 18:00 (UTC+8)',
  buyer: 'Comerciante',
  selfWarehouse: 'Armazém designado acbuy',
  warehouse: 'Armazém designado acbuy',
  yourAddress: 'Seu endereço',
  calcCountryFreight: 'Estimar frete internacional',
  holder: {
    remarkHolder:
      'Sua mensagem para o comprador, se não houver requisitos especiais, não precisa escrever; Sua mensagem, o comprador decidirá se executa de acordo com o comerciante e outras situações.',
  },
  supportPayment: 'Suporta pagamento',
  disclaimer:
    'Todos os produtos exibidos no acbuy que podem ser usados para serviços de agente de compras vêm de plataformas de compras terceirizadas, não são vendidos diretamente pelo acbuy. Portanto, o acbuy não assume qualquer responsabilidade e responsabilidade legal por problemas causados por violação de propriedade intelectual e violação de direitos autorais de produtos.',
  readAgree: 'Li e concordo com o acima',
  selectAgree: 'Ainda não concordou com o aviso legal',
  copyLink: 'Copiar link',
  copySuccess: 'Copiado com sucesso',
  disclaimer1: 'Aviso legal',
  editPrice: 'Alterar preço',
  editPriceTips:
    'Afetado pelas regras de recebimento de cupons de compra, cupons ou descontos de compra total podem não ser desfrutados. Recomendamos que o preço que você modificar seja consistente com o preço real de venda do vendedor!',
  editPriceEnum: {
    0: 'Desconto de transporte',
    1: 'Erro na cotação da página',
    2: 'Negociação com vendedor',
    3: 'Outros motivos',
  },
  imgTranslation: 'Tradução de imagem',
  translationTips: 'Clique na imagem para traduzir o texto',
  originTranslation: 'Imagem original/Tradução',
  qcImg: 'Imagens QC',
  deleteShopCollect: 'Tem certeza de que deseja excluir o favorito da loja?',
  inTransition: 'Convertendo...',
  originLink: 'Link original',
  singleProductData: 'Informações de produto único',
  recentlyViewed: 'Histórico de visualização',
}
